// Must stay 1:1 with CHART_SERIES_COLOR_CHOICES in
// src/main/blocks/data_visualization.py — exported series colors are saved
// into a Wagtail ChoiceBlock, so any color missing there fails validation
// ("This field is required") in the Wagtail admin.
export const CHART_COLORS = [
    '#4FA0FF',
    '#194C7A',
    '#FFB5B5',
    '#FF6779',
    '#FF9E55',
    '#E15E1F',
    '#0C2632',
    '#155777',
    '#69A0BB',
    '#99CDE6',
    '#D9EDF6',
    '#0C42FF',
    '#3D96FF',
    '#A4D1FF',
    '#FFDBDB',
    '#FFB1B1',
    '#FF5468',
    '#FF8C55',
    '#FFC79C',
    '#FFF9DA',
    '#CCEBBE',
    '#7ACE9A',
    '#1BAE70',
    '#F6FCFF',
];

export const getNextAvailableColor = (usedColors = []) => {
    const usedSet = new Set(usedColors.map((c) => c?.toUpperCase()));
    for (const color of CHART_COLORS) {
        if (!usedSet.has(color.toUpperCase())) {
            return color;
        }
    }
    // If all colors used, return first color
    return CHART_COLORS[0];
};

export const isColorUsed = (color, usedColors = []) => {
    const usedSet = new Set(usedColors.map((c) => c?.toUpperCase()));
    return usedSet.has(color?.toUpperCase());
};
